<template>
	<div>
		<nav class="navbar navbar-expand-lg navbar-light bg-light">
			<div class="container">
				<div class="navbar-brand" href="#">
					<img src="https://www.soleol.ch/assets/img/logo.svg" />
				</div>
				<ul class="navbar-nav ml-auto">
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Admin Soleol </a>
						<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
							<button class="dropdown-item" @click.prevent="signOut()">Log Out</button>
						</div>
					</li>
				</ul>
			</div>
		</nav>
		<div class="c-main__wrapper">

			<!-- Nav tabs -->
			<nav class="c-main__nav-main pt-4">
				<div class="container">
					<ul class="nav nav-tabs" role="tablist">
						<!-- <li class="nav-item">
							<a class="nav-link active" id="users-tab" data-toggle="tab" href="#users" role="tab" aria-controls="users" aria-selected="true" v-on:click.prevent="router('list-users')">
								<font-awesome-icon :icon="['fal', 'users']" class="mr-2" ></font-awesome-icon>
								Users
							</a>
						</li> -->
						<li class="nav-item">
							<a class="nav-link active" id="Files-tab" data-toggle="tab" href="#Files" role="tab" aria-controls="Files" aria-selected="true" v-on:click.prevent="router('files')">
								<font-awesome-icon :icon="['fal', 'file-pdf']" class="mr-2" ></font-awesome-icon>
								Files
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="category-tab" data-toggle="tab" href="#categories" role="tab" aria-controls="categories" aria-selected="false" v-on:click.prevent="router('categories')">
								<font-awesome-icon :icon="['fal', 'pennant']" class="mr-2" ></font-awesome-icon>
								Categories
							</a>
						</li>
					</ul>
				</div>
			</nav>

			<!-- Tab panes -->
			<div class="c-main__subnav-main content tab-content pt-3 pb-3">
				<!-- <div class="tab-pane active" id="users" role="tabpanel" aria-labelledby="users-tab">
					<div class="container">
						<ul class="nav">
							<li class="nav-item">
								<router-link to="/admin/list-users" class="nav-link">
									<font-awesome-icon :icon="['fal','list']" class="mr-2"></font-awesome-icon>
									List Users
								</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/admin/list-admins" class="nav-link">
									<font-awesome-icon :icon="['fal','list']" class="mr-2"></font-awesome-icon>
									List Admins
								</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/admin/add-user" class="nav-link">
									<font-awesome-icon :icon="['fal','plus']" class="mr-2"></font-awesome-icon>
									Add New User
								</router-link>
							</li>
						</ul>
					</div>
				</div> -->
				<div class="tab-pane active" id="Files" role="tabpanel" aria-labelledby="Files-tab">
					<div class="container">
						<ul class="nav">
							<li class="nav-item">
								<router-link to="/admin/files" class="nav-link">
									<font-awesome-icon :icon="['fal','list']" class="mr-2"></font-awesome-icon>
									List Files
								</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/admin/add-file" class="nav-link">
									<font-awesome-icon :icon="['fal','plus']" class="mr-2"></font-awesome-icon>
									Add New File
								</router-link>
							</li>
						</ul>
					</div>
				</div>
				<div class="tab-pane" id="categories" role="tabpanel" aria-labelledby="categories-tab">
					<div class="container">
						<ul class="nav">
							<li class="nav-item">
								<router-link to="/admin/categories" class="nav-link">
									<font-awesome-icon :icon="['fal','list']" class="mr-2"></font-awesome-icon>
									List Categories
								</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/admin/add-category" class="nav-link">
									<font-awesome-icon :icon="['fal','plus']" class="mr-2"></font-awesome-icon>
									Add Category
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { auth } from '../../firebase'

	export default {
		mounted() {
			this.$router.push('/admin/files')
		},
		methods: {
			router(route) {
				this.$router.push(`/admin/${route}`)
			},
			signOut() {
				auth.signOut().then( () => {
					this.$router.push('/')
				})
			}
		}
	}
</script>

<style>
	.navbar-brand{
		width: 180px;
	}
</style>



// WEBPACK FOOTER //
// src/components/admin/Nav.vue